module.exports = __webpack_public_path__ + "static/media/tab_reservation.3fcbb29c.svg";